export const getTimeDuration = (time, locale) => {
  let hourTextMark;
  let minuteTextMark;

  switch (locale) {
    case 'en':
      hourTextMark = 'h';
      minuteTextMark = 'min';
      break;
    case 'es':
      hourTextMark = 'h';
      minuteTextMark = 'min';
      break;
    case 'de': 
      hourTextMark = 'st';
      minuteTextMark = 'min';
      break;
    default:
      hourTextMark = 'ч';
      minuteTextMark = 'мин';
  }

  if (time < 60) {
    return `${time} ${minuteTextMark}`;
  }

  const hours = Math.floor(time / 60);
  const minutes = Math.floor(time % 60);

  return `${hours} ${hourTextMark} ${minutes} ${minuteTextMark}`;
};
